(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda got to day 
    module.directive('agendaGoToDay', [
            'AgendaOverviewService', 
            'AgendaTransitionService', 
            'SharedAgendaService', 
            '$uibModalStack',
        function (AgendaOverviewService, 
                  AgendaTransitionService, 
                  SharedAgendaService, 
                  $uibModalStack) {

            var directive = {
                restrict: 'A',
                link: link,
                scope: {
                    date: '<',
                    agendaId: '<?'
                }
            };
            return directive;

            function link(scope, element) {

                // click listener
                element.on('click', function () {
                    openAgendaOnDay();
                });

                // show agenda-day-view
                function openAgendaOnDay() {
                    if (scope.agendaId) {
                        var agenda = SharedAgendaService.getAgenda(scope.agendaId);                        
                        AgendaTransitionService.change(agenda.owner.id, scope.date);
                    } else {
                        AgendaOverviewService.showAgendaPerDay(scope.date);
                    }
                    $uibModalStack.dismissAll();
                } // show

                // on destroy
                scope.$on("$destroy", function () {
                    element.off("click");
                });
            }
        }]);

})();